import React, { useState } from 'react'
import { HStack, Button, IconButton, useColorMode, Link, Menu, MenuButton, MenuList, MenuItem, Container } from '@chakra-ui/react'
import { FaSun, FaMoon, FaBars } from 'react-icons/fa'
import CV from '../assets/Resume-MS.pdf'
import '../App.css'

function Header() {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => setIsOpen(!isOpen)

    const { colorMode, toggleColorMode } = useColorMode()
    const isDark = colorMode === 'dark'

  return (
    <div className={ isDark ? 'nav-dark' : 'nav'} id='header'>
        <a href={ isDark ? "#home" : '#home_light'}><strong>Mac's portfolio</strong></a>

        <div className='main-container'>
    
        <div className='nav-menu'>
            <a className='nav-link' href='#about'>About</a>
            <a className='nav-link' href='#skills'>Skills</a>
            <a className='nav-link' href='#projects'>Projects</a>
            <a className='nav-link' href='#contact'>Contact</a>

            <HStack>
              <Link download='' href={CV} >
                <Button colorScheme='#c79292' variant='outline'>Resume</Button>
              </Link>
            </HStack>   

            <IconButton ml={8} isRound='true' icon={ isDark ? <FaSun /> : <FaMoon />} onClick={toggleColorMode} />            
        </div>

        <Menu className='icon-bars'>
          <MenuButton
            as={IconButton}
            aria-label='Options'
            icon={<FaBars />}
            variant='outline'
            className='icon-bars'
          />

          <MenuList>
            <MenuItem>
            <a className='nav-link' href='#about'>About</a>
            </MenuItem>
            <MenuItem>
            <a className='nav-link' href='#skills'>Skills</a>
            </MenuItem>
            <MenuItem>
            <a className='nav-link' href='#projects'>Projects</a>
            </MenuItem>
            <MenuItem>
            <a className='nav-link' href='#contact'>Contact</a>
            </MenuItem>
            <Container pt={2}>
              <IconButton ml={2} isRound='true' icon={ isDark ? <FaSun /> : <FaMoon />} onClick={toggleColorMode} />
            </Container> 
          </MenuList>
        </Menu>

        </div>              
    </div>
  )
}

export default Header